import React from 'react';
import { Box } from 'grommet';
import { Bell } from '@styled-icons/fa-solid/Bell';
import styled from 'styled-components';
import { StyledSpan } from 'granite-admin/core/components/Animations/SkeletonAnimation';
const LogoBox = styled(StyledSpan)`
  height: 42px;
  width: 85px;
`;
const LabelBox = styled(StyledSpan)`
  width: 80px;
  height: 25px;
`;
const IconBox = styled(StyledSpan)`
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;
const TopNavbarSkeletonLoader = () => {
  return /*#__PURE__*/React.createElement(Box, {
    fill: "horizontal",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "medium",
    align: "center"
  }, /*#__PURE__*/React.createElement(LogoBox, null), [...Array(5).keys()].map((i, ind) => /*#__PURE__*/React.createElement(LabelBox, {
    key: ind + 'top-nav-bar-item'
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "small",
    align: "center"
  }, /*#__PURE__*/React.createElement(Bell, {
    size: "20px",
    color: "#e8e8e8",
    style: {
      marginRight: '20px'
    }
  }), /*#__PURE__*/React.createElement(LabelBox, null), /*#__PURE__*/React.createElement(IconBox, null)));
};
export default TopNavbarSkeletonLoader;